import { Route, Routes } from "react-router-dom";
import RequireAuth from "../components/RequireAuth";
import Login from "../pages/Auth/Login";
import Home from "../pages/Home";
import Campaigns from "../pages/Campaigns";
import Users from "../pages/Users";
import CampaignTemplates from "../pages/Templates";
import Audiences from "../pages/Audiences";
import NewCampaign from "../pages/Campaigns/NewCampaign";
import SetCampaignName from "../pages/Campaigns/SetCampaignName";
import SetCampaignAudience from "../pages/Campaigns/SetCampaignAudience";
import SetCampaignTemplate from "../pages/Campaigns/SetCampaignTemplate";
import CreateNewTemplate from "../pages/Campaigns/CreateNewTemplate";
import SetCampaignSchedule from "../pages/Campaigns/SetCampaignSchedule";
import CampaignEditTemplate from "../pages/Campaigns/EditTemplate";
import CampaignOthers from "../pages/Campaigns/SetOthers";
import CampaignErrors from "../pages/Campaigns/CampaignErrors";
import NewTemplate from "../pages/Templates/new";
import EditTemplate from "../pages/Templates/edit";
import BlockContactsByGlobal from "../pages/BlockContacts/BlockContactsByGlobal";
import BlockContactsByCampaign from "../pages/BlockContacts/BlockContactsByCampaign";
import BlockContactsByTags from "../pages/BlockContacts/BlockContactsByTags";
import Report from "../components/Report/Report";
import CampaignReportPage from "../components/Report/CampaignReportPage";
import CampaignRunReport from "../components/Report/EmailCampaignRunReport/RunReport";
import CampaignRunReportByUuid from "../components/Report/EmailCampaignRunReport/CampaignByUuid";
import DataIssueComponent from "../components/Report/EmailCampaignRunReport/EmailDataIssues/DataIssueTable";
import EmailSupressionList from "../components/Report/SuppressionList.js/EmailSupressionList";
import SetVendorConfiguration from "../pages/Campaigns/VendorConfig/SetVendorConfiguration";
import HodublastUploadReportView from "../components/Report/HodublastReport/HodublastUploadReportView";
import JobList from "../components/JobList/JobListSection";
import BulkSuppressionDeleteReport from "../components/Report/SuppressionList.js/BulkSuppressionDeleteReport";
import DailyIVRCampaignRunReport from "../components/Report/HodublastReport/DailyIvrRunReport";
import ViewSmsCampaignReport from "../components/Report/SmsCampaignReport/ViewSmsCampaignReport";
import SmsCampaignSummaryTable from "../components/Report/SmsCampaignReport/SmsCampaignSummaryTable";
import DownloadReportView from "../components/Download/DownloadReportView";
import PermissionManagement from "../components/RolesAndPermissions/PermissionsManagement/PermissionManagement";
import RolesManagement from "../components/RolesAndPermissions/RolesManagement/RolesManagement";
import Unauthorize from "../components/unauthorize/Unauthorize";
import IpManagement from "../components/IpManagement/IpManagement";
import DailySMSCampaignRunReport from "../components/Report/SmsCampaignReport/DailySmsRunReport";
import SmartConnectSettings from "../components/SmartConnect/SmartConnectSetting/SmartConnectSettings";
import SmartConnectAgentList from "../components/SmartConnect/SmartConnectAgentList";
import SmartConnectAddDids from "../components/SmartConnect/AddDids";
import SmartConnectSummary from "../components/SmartConnect/SmartConnectSummary";
import SmartConnectDidAssignment from "../components/SmartConnect/DidAssignmentList/SmartConnectDidAssignment";
import SmartConnectAssignDidsView from "../components/SmartConnect/SmartConnectAssignDidsView";
import SmartConnectDeletedDidList from "../components/SmartConnect/SmartConnectDeletedDidList";
import ViCtsListView from "../components/ViCts/ViCtsListView/ListView";
import ViCtsTransferSetting from "../components/ViCts/ViCtsTransferSetting/TransferSetting";
import DidAssignmentList from "../components/SmartConnect/DidAssignmentList/DidAssignmentList";
import SetCampaignSetting from "../pages/Campaigns/SetCampaignSetting";
import LeadsDataTransferSetting from "../components/LeadsDataTransferSetting/LeadsDataTransferSetting";
import PreLeads from "../components/PreLeads/PreLeads";

export function RenderRoutes({ routes }) {
  return (
    <Routes>
      <Route
        key={"ROOT"}
        path={"/"}
        exact={true}
        element={
          <RequireAuth>
            <Home />
          </RequireAuth>
        }
      />

      <Route key={"LOGIN"} path={"/login"} exact={true} element={<Login />} />

      <Route
        key={"APP"}
        path={"/app"}
        exact={false}
        element={
          <RequireAuth>
            <Home />
          </RequireAuth>
        }
      />
      <Route
        key={"CAMPAIGNS"}
        path={"/campaigns"}
        exact={true}
        element={
          <RequireAuth>
            <Campaigns />
          </RequireAuth>
        }
      />

      <Route
        key={"SMARTCONNECTSETTINGS"}
        path={"/smart-connect/settings"}
        exact={true}
        element={
          <RequireAuth>
            <SmartConnectSettings />
          </RequireAuth>
        }
      />

      <Route
        key={"SMARTCONNECTAGENTLIST"}
        path={"/smart-connect/agent-list"}
        exact={true}
        element={
          <RequireAuth>
            <SmartConnectAgentList />
          </RequireAuth>
        }
      />

      <Route
        key={"SMARTCONNECTADDDIDS"}
        path={"/smart-connect/add-dids"}
        exact={true}
        element={
          <RequireAuth>
            <SmartConnectAddDids />
          </RequireAuth>
        }
      />

      <Route
        key={"SMARTCONNECTSUMMARY"}
        path={"/smart-connect/summary"}
        exact={true}
        element={
          <RequireAuth>
            <SmartConnectSummary />
          </RequireAuth>
        }
      />

      <Route
        path="/smart-connect/did-assignments"
        element={
          <RequireAuth>
            <SmartConnectDidAssignment />
          </RequireAuth>
        }
      >
        <Route path=":groupId" element={<DidAssignmentList />} />
      </Route>

      <Route
        key={"SMARTCONNECTDIDVIEW"}
        path={"/smart-connect/did-assignments/:group_id/view-dids"}
        exact={true}
        element={
          <RequireAuth>
            <SmartConnectAssignDidsView />
          </RequireAuth>
        }
      />

      {/* smart-connect/deleted-dids */}
      <Route
        key={"SMARTCONNECTDELETEDDIDS"}
        path={"/smart-connect/deleted-dids"}
        exact={true}
        element={
          <RequireAuth>
            <SmartConnectDeletedDidList />
          </RequireAuth>
        }
      />

      <Route
        key={"CAMPAIGNSNEW"}
        path={"/campaigns/new"}
        exact={false}
        element={
          <RequireAuth>
            <NewCampaign />
          </RequireAuth>
        }
      />
      <Route
        key={"CAMPAIGNSNEW"}
        path={"/campaigns/new/campaign"}
        exact={false}
        element={
          <RequireAuth>
            <SetCampaignName />
          </RequireAuth>
        }
      />
      <Route
        key={"CAMPAIGNSNEW"}
        path={"/campaigns/edit/campaign/:id"}
        exact={false}
        element={
          <RequireAuth>
            <SetCampaignName />
          </RequireAuth>
        }
      />
      <Route
        key={"CAMPAIGNSNEWAUDIENCE"}
        path={"/campaigns/edit/audience/:id"}
        exact={false}
        element={
          <RequireAuth>
            <SetCampaignAudience />
          </RequireAuth>
        }
      />
      <Route
        key={"CAMPAIGNSNEWTEMPLATE"}
        path={"/campaigns/edit/template/:id"}
        exact={false}
        element={
          <RequireAuth>
            <SetCampaignTemplate />
          </RequireAuth>
        }
      />

      <Route
        key={"CAMPAIGNVENDORCONFIGURATION"}
        path={"/campaigns/edit/vendor-config/:id"}
        exact={false}
        element={
          <RequireAuth>
            <SetVendorConfiguration />
          </RequireAuth>
        }
      />

      <Route
        key={"CAMPAIGNSUPDATETEMPLATE"}
        path={"/campaigns/edit/update-template/:id/:templateId"}
        exact={false}
        element={
          <RequireAuth>
            <CampaignEditTemplate />
          </RequireAuth>
        }
      />

      <Route
        key={"CAMPAIGNSNEWTEMPLATENEW"}
        path={"/campaigns/edit/createtemplate/:id"}
        exact={false}
        element={
          <RequireAuth>
            <CreateNewTemplate />
          </RequireAuth>
        }
      />
      <Route
        key={"CAMPAIGNSNEWSCHEDULR"}
        path={"/campaigns/edit/schedule/:id"}
        exact={false}
        element={
          <RequireAuth>
            <SetCampaignSchedule />
          </RequireAuth>
        }
      />

      <Route
        key={"CAMPAIGNSNEWSCHEDULR"}
        path={"/campaigns/edit/setting/:id"}
        exact={false}
        element={
          <RequireAuth>
            <SetCampaignSetting />
          </RequireAuth>
        }
      />

      <Route
        key={"CAMPAIGNSOTHERS"}
        path={"/campaigns/edit/others/:id"}
        exact={false}
        element={
          <RequireAuth>
            <CampaignOthers />
          </RequireAuth>
        }
      />

      <Route
        key={"CAMPAIGNSERRORS"}
        path={"/campaigns/errors"}
        exact={false}
        element={
          <RequireAuth>
            <CampaignErrors />
          </RequireAuth>
        }
      />
      <Route
        key={"TEMPLATESNEW"}
        path={"/templates/new"}
        exact={false}
        element={
          <RequireAuth>
            <NewTemplate />
          </RequireAuth>
        }
      />

      <Route
        key={"TEMPLATESEDIT"}
        path={"/templates/edit/:id"}
        exact={false}
        element={
          <RequireAuth>
            <EditTemplate />
          </RequireAuth>
        }
      />

      <Route
        key={"USERS"}
        path={"/users"}
        exact={false}
        element={
          <RequireAuth>
            <Users />
          </RequireAuth>
        }
      />
      <Route
        key={"CAMPAIGNTEMPLATE"}
        path={"/templates"}
        exact={false}
        element={
          <RequireAuth>
            <CampaignTemplates />
          </RequireAuth>
        }
      />
      <Route
        key={"AUDIENCES"}
        path={"/audiences"}
        exact={false}
        element={
          <RequireAuth>
            <Audiences />
          </RequireAuth>
        }
      />

      <Route
        key={"BLOCKCONTACTSBYGLOBAL"}
        path={"/block-contacts/global"}
        element={
          <RequireAuth>
            <BlockContactsByGlobal />
          </RequireAuth>
        }
      />

      <Route
        key={"BLOCKCONTACTSBYCAMPAIGN"}
        path={"/block-contacts/campaign"}
        element={
          <RequireAuth>
            <BlockContactsByCampaign />
          </RequireAuth>
        }
      />

      <Route
        key={"BLOCKCONTACTSBYTAGS"}
        path={"/block-contacts/tags"}
        element={
          <RequireAuth>
            <BlockContactsByTags />
          </RequireAuth>
        }
      />
      <Route
        key={"REPORT"}
        path="/campaign/report"
        element={
          <RequireAuth>
            <Report />
          </RequireAuth>
        }
      ></Route>
      <Route
        key={"SINGLEREPORT"}
        path="/campaign/report/:campaignId"
        element={
          <RequireAuth>
            <CampaignReportPage />
          </RequireAuth>
        }
      ></Route>

      <Route
        key={"RUNREPORT"}
        path="/campaign/email-campaing-report"
        element={
          <RequireAuth>
            <CampaignRunReport />
          </RequireAuth>
        }
      ></Route>

      <Route
        key={"RUNREPORTBYUUID"}
        path="/campaign/email-campaing-report/:campaignUuid"
        element={
          <RequireAuth>
            <CampaignRunReportByUuid />
          </RequireAuth>
        }
      ></Route>

      <Route
        key={"CAMPAIGNDATAISSUE"}
        path="/campaign/email-campaing-report/:campaignUuid/data-issues/:campaignId/:type"
        element={
          <RequireAuth>
            <DataIssueComponent />
          </RequireAuth>
        }
      ></Route>

      {/* email suppression list view */}
      <Route
        key={"EMAILSUPPRESSIONLIST"}
        path="/campaign/email-suppression-list"
        element={
          <RequireAuth>
            <EmailSupressionList />
          </RequireAuth>
        }
      ></Route>

      {/* bulk suppression delete report section */}
      <Route
        key={"EMAILSUPPRESSIONLIST"}
        path="/campaign/email-suppression-list/bulk-suppression-delete-report"
        element={
          <RequireAuth>
            <BulkSuppressionDeleteReport />
          </RequireAuth>
        }
      ></Route>

      {/* Hodublast report section */}
      <Route
        key={"HODUBLASTUPLOADREPORT"}
        path="/campaign/ivr-campaign-report"
        element={
          <RequireAuth>
            <DailyIVRCampaignRunReport />
          </RequireAuth>
        }
      ></Route>

      <Route
        key={"HODUBLASTUPLOADREPORT_VIEW"}
        path="/campaign/ivr-campaign-report/:campaignUuid"
        element={
          <RequireAuth>
            <HodublastUploadReportView />
          </RequireAuth>
        }
      ></Route>

      <Route
        key={"SMSCAMPAIGNREPORT"}
        path="/campaign/sms-campaign-report"
        element={
          <RequireAuth>
            <DailySMSCampaignRunReport />
          </RequireAuth>
        }
      ></Route>

      <Route
        key={"SMSCAMPAIGNDATAISSUESUMMARYTABLE"}
        path="/campaign/sms-campaign-report/:campaignUuid/data-issues/:campaignId/:type"
        element={
          <RequireAuth>
            <SmsCampaignSummaryTable />
          </RequireAuth>
        }
      ></Route>

      <Route
        key={"VIEWSMSCAMPAIGNREPORT"}
        path="/campaign/sms-campaign-report/:campaignUuid"
        element={
          <RequireAuth>
            <ViewSmsCampaignReport />
          </RequireAuth>
        }
      ></Route>

      <Route
        path="/download/:uuid"
        element={
          <RequireAuth>
            <DownloadReportView />
          </RequireAuth>
        }
      />

      <Route
        key={"JOBLIST"}
        path="/job-list"
        element={
          <RequireAuth>
            <JobList />
          </RequireAuth>
        }
      ></Route>

      {/* Roles and Permissions */}
      <Route
        key={"ROLEMANAGEMENT"}
        path="/roles-management"
        element={
          <RequireAuth>
            <RolesManagement />
          </RequireAuth>
        }
      ></Route>
      <Route
        key={"VIEWPERMISSIONS"}
        path="/roles-management/permissions/view/:role_id"
        element={
          <RequireAuth>
            <PermissionManagement />
          </RequireAuth>
        }
      ></Route>

      <Route
        key={"IPMANAGEMENT"}
        path="/ip-management"
        element={
          <RequireAuth>
            <IpManagement />
          </RequireAuth>
        }
      ></Route>

      <Route
        key={"UNAUTHORIZE"}
        path="/unauthorized"
        element={
          <RequireAuth>
            <Unauthorize />
          </RequireAuth>
        }
      ></Route>

      <Route
        key={"VI-CTS"}
        path="/vi-cts/ListView"
        element={
          <RequireAuth>
            <ViCtsListView />
          </RequireAuth>
        }
      ></Route>

      <Route
        key={"VI-CTS"}
        path="/vi-cts/TransferSetting"
        element={
          <RequireAuth>
            <ViCtsTransferSetting />
          </RequireAuth>
        }
      ></Route>

      <Route
        key={"LEADS_DATA_TRANSFER_SETTING"}
        path="/leads-data-transfer-setting"
        element={
          <RequireAuth>
            <LeadsDataTransferSetting />
          </RequireAuth>
        }
      ></Route>

      <Route
        key={"PRE-LEADS"}
        path="/pre-leads"
        element={
          <RequireAuth>
            <PreLeads />
          </RequireAuth>
        }
      ></Route>

      <Route component={() => <h1>Not Found!</h1>} path="/not-found" />
    </Routes>
  );
}
